export const NODE_VALUES = {
  LOCATION: 'Location'
};

export const VALID_S3_FILENAME_REGEX = /^([0-9]|[A-Z]|[a-z]|[!\-_.*'()])+$/;
